/* RESPONSIBLE TEAM: team-standalone */

import StandardOnboardingGuideStep from '../standard-onboarding-guide-step';
import type ZendeskPlatform from '../../zendesk';

export default class ZendeskOnboardingGuideStep extends StandardOnboardingGuideStep {
  declare protected platform: ZendeskPlatform;

  override moreInfoLinkLabel(stepIdentifier: string): string | null {
    if (stepIdentifier === 'fin_sa_onboarding_add_support_content') {
      return this.platform.intl.t(
        'onboarding.getting-started.platforms.zendesk.article-sync-zendesk',
      );
    }
    if (stepIdentifier === 'fin_sa_onboarding_connect_channels_and_turn_fin_live') {
      return this.platform.intl.t(
        'onboarding.getting-started.platforms.zendesk.how-fin-integrates-zendesk',
      );
    }
    return null;
  }

  override moreInfoArticleId(stepIdentifier: string): number | undefined {
    if (stepIdentifier === 'fin_sa_onboarding_add_support_content') {
      return 10617194;
    }
    if (stepIdentifier === 'fin_sa_onboarding_connect_channels_and_turn_fin_live') {
      return 10602087;
    }
    return undefined;
  }

  override shouldShowConnectDrawer(stepIdentifier: string): boolean {
    return stepIdentifier === 'fin_sa_onboarding_add_integration';
  }
}
